<template>
  <div class="bottom-outter">
    <div>
        <border style="width: 620px;height: 350px;">
            <template v-slot:title>
                <customTitle text="虚仿实训人数累计TOP5" />
            </template>
            <template v-slot:tabledata>
                <bar />
                <!-- <dv-capsule-chart :config="config" style="width:300px;height:200px" /> -->
            </template>
        </border>
    </div>
    <div>
        <border style="width: 500px;height: 350px;">
            <template v-slot:title>
                <customTitle text="教学资源类型占比" />
            </template>
            <template v-slot:tabledata>
                <pie />
            </template>
        </border>
    </div>
    <div>
        <border style="width: 660px;height: 350px;">
            <template v-slot:title>
                <customTitle text="在线虚仿实时详情" />
            </template>
            <template v-slot:tabledata>
                <scrollBoard />
            </template>
        </border>
    </div>
  </div>
</template>

<script>
import border from '@/components/main/components/border.vue'
import customTitle from '@/components/main/components/title.vue'
import scrollBoard from './scroll-board.vue'
import pie from './pie.vue'
import bar from './bar.vue'
export default {
    components: {
        border,
        customTitle,
        pie,
        bar,
        scrollBoard
    }
}
</script>

<style scoped>
.bottom-outter {
    width: 1846px;
    height: 350px;
    /* background: red; */
    margin-top: 25px;
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
}
.dv-capsule-chart {
    width: 590px !important;
    height: 280px !important;
}
</style>